var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcoWhite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.744 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style_x3D_fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector__x28_Stroke_x29_",
    d: "M93.023,195.349C93.023,87.46,180.484,0,288.372,0s195.349,87.46,195.349,195.349-87.46,195.349-195.349,195.349-195.349-87.46-195.349-195.349Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rec__x28_Stroke_x29_",
    d: "M0,644.517c0-109.354,88.651-198.006,198.007-198.006h180.732c109.354,0,198.006,88.651,198.006,198.006,0,85.872-69.611,155.483-155.483,155.483H155.482C69.612,800,0,730.389,0,644.517Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcoWhite);
export default __webpack_public_path__ + "static/media/user-ico-white.82d3370daca0fe3d8400d6631605eb94.svg";
export { ForwardRef as ReactComponent };